import { Row, Col, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Component } from 'react'

interface Props {
  close: () => void
  title: string
}

const { Title } = Typography

export class ModalHeader extends Component<Props> {
  render() {
    const { close, title } = this.props
    return (
      <Row gutter={22} style={{ marginTop: 0 }}>
        <Col span={18}>
          <Title level={3}>
            <b>{title}</b>
          </Title>
        </Col>
        <Col span={6} style={{ justifyContent: 'flex-end', display: 'flex' }}>
          <CloseCircleOutlined style={{ fontSize: 22 }} onClick={() => close()} />
        </Col>
      </Row>
    )
  }
}
